export const BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1440,
    xxl: 1920,
} as const;

export type BreakpointSize = keyof typeof BREAKPOINTS;
